module.exports = __webpack_public_path__ + "static/media/DataRoomViewer.ed5ef57b.png";